interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <nav className="mt-8 flex flex-wrap items-center justify-center gap-2" aria-label="分页导航">
      <button
        type="button"
        onClick={() => onChange(page - 1)}
        disabled={page <= 1}
        className="flex h-9 cursor-pointer items-center gap-1 rounded-md border border-background-300 bg-background-50 px-3 font-label text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <span className="flex h-4 w-4 items-center justify-center">
          <i className="ri-arrow-left-s-line text-base"></i>
        </span>
        上一页
      </button>

      {pages.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onChange(p)}
          aria-current={p === page ? "page" : undefined}
          className={`flex h-9 w-9 cursor-pointer items-center justify-center rounded-md font-label text-sm transition-colors ${
            p === page
              ? "bg-primary-500 font-semibold text-background-50"
              : "border border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
          }`}
        >
          {p}
        </button>
      ))}

      <button
        type="button"
        onClick={() => onChange(page + 1)}
        disabled={page >= totalPages}
        className="flex h-9 cursor-pointer items-center gap-1 rounded-md border border-background-300 bg-background-50 px-3 font-label text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40"
      >
        下一页
        <span className="flex h-4 w-4 items-center justify-center">
          <i className="ri-arrow-right-s-line text-base"></i>
        </span>
      </button>
    </nav>
  );
}